var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "SplitPane",
    { staticClass: "fps" },
    [
      _c(
        "div",
        {
          staticStyle: { height: "100%" },
          attrs: { slot: "left" },
          slot: "left"
        },
        [
          _vm.metrics.fps
            ? _c(
                "div",
                {
                  ref: "chart",
                  staticClass: "chart",
                  on: { wheel: _vm.onMouseWheel }
                },
                [
                  _c(
                    "div",
                    { staticClass: "markers" },
                    _vm._l(_vm.fpsMarkers, function(marker) {
                      return _c(
                        "div",
                        {
                          key: marker.time,
                          staticClass: "marker",
                          class: {
                            selected: _vm.selectedMarker === marker
                          },
                          style: _vm.getMarkerStyle(marker),
                          on: {
                            click: function($event) {
                              _vm.selectedMarker = marker
                            }
                          }
                        },
                        _vm._l(marker.bubbles, function(bubble) {
                          return _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: {
                                    content:
                                      bubble.entries.length + " " + bubble.type,
                                    delay: { show: 100, hide: 0 }
                                  },
                                  expression:
                                    "{\n              content: `${bubble.entries.length} ${bubble.type}`,\n              delay: { show: 100, hide: 0 }\n            }"
                                }
                              ],
                              key: bubble.type,
                              staticClass: "bubble",
                              style: _vm.getBubbleStyle(bubble)
                            },
                            [
                              _c("div", { staticClass: "label" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(bubble.type.charAt(0)) +
                                    "\n            "
                                )
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    }),
                    0
                  ),
                  _c(
                    "div",
                    { staticClass: "row bars" },
                    _vm._l(_vm.metrics.fps, function(metric, index) {
                      return _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: {
                                content: _vm.getBarTootip(metric),
                                delay: { show: 100, hide: 0 }
                              },
                              expression:
                                "{\n            content: getBarTootip(metric),\n            delay: { show: 100, hide: 0 }\n          }"
                            }
                          ],
                          key: index,
                          staticClass: "bar-wrapper",
                          on: {
                            click: function($event) {
                              return _vm.onMetricClick(metric)
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass: "bar",
                            style: _vm.getMetricStyle(metric)
                          })
                        ]
                      )
                    }),
                    0
                  )
                ]
              )
            : _vm._e()
        ]
      ),
      _c("FramerateMarkerInspector", {
        attrs: { slot: "right", marker: _vm.selectedMarker },
        slot: "right"
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }